import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FormatService } from '../services/format.service';
import { sEvent } from '../models/sevent.model';

@Injectable({
  providedIn: 'root',
})
export class EventSearchService {
  apiHost: string = environment.apiHost;
  public eventArr: sEvent[] = [];
  constructor(private http: HttpClient, private _format: FormatService) {}

  async getEventsByDate(day: string, groupId: number, venue: string): Promise<sEvent[]> {
    try {
      const params = new HttpParams().set('Day', day).set('ServiceGroupId', groupId).set('Venue', venue || '');
      const data = await firstValueFrom(this.http.get<sEvent[]>(this.apiHost + '/event/geteventsByDate', {params}).pipe(timeout(15000)));
      if (!Array.isArray(data)) throw new Error('Invalid event response');
      this.eventArr = data;
      return data;
    } catch (error) {
      this.eventArr = [];
      throw error;
    }
  }

  getTodaysEvents(day: string): Promise<sEvent[]> {
    let promise = new Promise<sEvent[]>((resolve, reject) => {
      return this.http
        .get<sEvent[]>(this.apiHost + '/event/getTodaysEvents?Day=' + day)
        .toPromise()
        .then(
          (data) => {
            this.eventArr = data;
            resolve(this.eventArr);
          },
          (msg) => {
            this.eventArr = null;
            resolve(this.eventArr);
          }
        );
    });
    return promise;
  }
}
